$(document).ready(function(){


function removeClassWithPrefix(element,classPrefix){

    var regex = new RegExp("(^|\\s)"+classPrefix+"\\S+", "g");

    element.removeClass(function (index, css) {
        return (css.match (regex) || []).join(' ');
    });

}


/* =========================================================================
  Active Thumbs Bug Fix
========================================================================= */

if (window.location.href.includes('products')){
  $('.flex-control-nav').first().addClass('active')
}

  /* =========================================================================
      Product Card Color Swatch
  ========================================================================= */


  $(document).on('click', '.js-product-card-color-swatch', function(e){

      var $this = $(this);

      $this.addClass('selected').siblings().removeClass('selected');

      // data

      var productHandle = $this.data('product-handle');

      var productID = $this.data('product-id');

      var variantID = $this.data('variant-id');

      var productUrl = $this.data('product-url');

      var productTitle = $this.data('product-title');

      var productPrice = $this.data('product-price-html');

      // end of data

      // element

      var $productCard = $this.parents('.product-card');

      var $productCardAlbum = $productCard.find('.product-card-album');

      var $productCardLink = $productCard.find('.product-card-link');

      var $productCardTitle = $productCard.find('.product-card-title');

      var $productCardPrice = $productCard.find('.product-card-price');


      // end of element


      $productCardAlbum.removeClass('active')
      .filter('[data-product-handle="' + productHandle + '"]').addClass('active');


      $productCardLink.attr('href', productUrl);

      $productCardTitle.html(productTitle);
      $productCardPrice.html(productPrice);

  });



  /* =========================================================================
      Product Shop Color Swatch
  ========================================================================= */


  $(document).on('click', '.js-product-shop-color-swatch', function(){

      var $this = $(this);


      $this.addClass('selected').siblings().removeClass('selected');
      $this.addClass('selected-value').siblings().removeClass('selected-value');

      // data


      var productHandle = $this.data('product-handle');

      var productID = $this.data('product-id');

      var variantID = $this.data('variant-id');

      var productUrl = $this.data('product-url');

      var productTitle = $this.data('product-title');
      var productColor = $this.data('product-color');
      
     // console.log("Color: " + productColor)

      //var productDescription = $this.data('product-description-html');

      var productBtnText = $this.data('product-btn-text');

      var productBtnJSClass = $this.data('product-btn-js-class');


      //var variantID = $this.data('variant-id');

      var variantSku = $this.data('product-sku');

      var productFitDescription = $this.data('product-fit-description');
      var productColorDescription = $this.data('product-color-description');

      var productUpRise = $this.data('product-rise');
       var productInseam = $this.data('product-inseam');
       var productLegOpening = $this.data('product-legopening');
       //var productBodyLength = $this.data('product-bodylength');
       var productSizing = $this.data('product-sizing');
       var productFitNotes = $this.data('product-fitnotes');
       var productModelSize = $this.data('product-modelsize');
       var productFabric = $this.data('product-fabric');
       var productFabricDescription = $this.data('product-fabric-description');
       var productFabricUrl = $this.data('product-fabric-url');
       var productFabricComp = $this.data('product-fabric-comp');

    
      var variantPrice = $this.data('variant-price-html');
    
    //console.log('asad price',variantPrice);
    
      var variantInventoryQTY = $this.data('variant-inventory-quantity');

      var variantIncomingDate = $this.data('variant-incoming-date');

      var variantIsLowInStock = $this.data('variant-is-low-in-stock');

      var variantIsBackOrder = $this.data('variant-is-back-order');

      var variantIsSoldOut = $this.data('variant-is-sold-out');

      var variantIsFinalSale = $this.data('variant-is-final-sale');

      // end of data

      // element

      var $productShop = $this.parents('.product-shop');

      var $productShopAlbum = $productShop.find('.product-shop-album');
      var $proImageSlider = $productShop.find('.pro-image-slider');

      var $productShopEditorialAlbum = $productShop.find('.product-shop-editorial-album');

      var $productShopSelector = $productShop.find('.product-shop-selector');

      var $productShopVariants = $productShopSelector.find('.product-shop-variants');

      var $productShopVariant = $productShopVariants.find('.product-shop-variant');

      var $productShopOptions = $productShopSelector.find('.product-shop-options');

      var $productShopSku = $productShop.find('.variant-sku')
      var $productDynamicFabric = $productShop.find('.product-dynamic-fabric')
      var $productDynamicFabricDescription = $productShop.find('.product-dynamic-fabric-Description')
      var $productDynamicFabricUrl = $productShop.find('.product-dynamic-fabric-url')
      var $productShopOptionValue = $productShopOptions.find('.product-shop-option-value');
      var $productCombDynamicFabric = $('.product-comb-dynamic-fabric');

      var $productShopTitle = $productShop.find('.product-shop-title');
      var $productShopColor = $productShop.find('.product-shop-wash');
    
      var $productShopFitDescription = $productShop.find('.fit-description');
      var $productShopColorDescription = $productShop.find('.color-description');

      var $productShopRise = $productShop.find('.product-update-rise');
      var $productShopInseam = $productShop.find('.product-inseam');
      var $productShopLegOpening = $productShop.find('.product-legopening');
      //var $productShopBodyLength = $productShop.find('.product-bodylength');
      var $productShopSizing = $productShop.find('.product-sizing');
      var $productShopFitNotes = $productShop.find('.product-fitnotes');
      var $productShopModelSize = $productShop.find('.product-modelsize');
      var $productShopFabricComp = $productShop.find('.compcode');



    

      var $productShopPrice = $productShop.find('.product-shop-price');

      // var $productShopDescription = $productShop.find('.product-shop-description');
      //var $productShopDescription = $productShop.find('.desc');

      var $inventoryNotice = $productShop.find('.product-shop-inventory-notice');

      var $incomingNotice = $productShop.find('.product-shop-incoming-notice');

      var $addToCartBtn = $productShop.find('.product-add-to-cart');



      // end of element

      // update album
    

    

      $productShopAlbum.removeClass('active')
      .filter('[data-product-handle="' + productHandle + '"]').addClass('active');
    
      $proImageSlider.removeClass('active')
      .filter('[data-product-handle="' + productHandle + '"]').addClass('active');



      $productShopEditorialAlbum.removeClass('active')
      .filter('[data-product-handle="' + productHandle + '"]').addClass('active');


      $('.flex-control-nav').removeClass('active')

      var $active = $('[data-product-handle="' + productHandle + '"].active')


      var $siblingOl = $active.siblings().first()
          //$siblingOl.addClass('active')


      // hide flexTHumbs


      // update selector

      $productShopSelector.removeClass('active')
      .filter('[data-product-handle="' + productHandle + '"]').addClass('active');


      // reset variant

      $productShopVariant.removeClass('selected')
      .filter('.default').addClass('selected');


      // reset option

      $productShopOptionValue.removeClass('selected')
      .filter('.default').addClass('selected');


      // update color name
      $productShopTitle.html(productTitle);
      $productShopColor.html(productColor);

    
      // Product update description
      $productShopFitDescription.html(productFitDescription);
      $productShopColorDescription.html(productColorDescription);
      $productShopRise.html(productUpRise)


      $productShopRise.html(productUpRise);
      $productShopInseam.html(productInseam);
      $productShopLegOpening.html(productLegOpening);
      //$productShopBodyLength.html(productBodyLength);
      $productShopSizing.html(productSizing);
      $productShopFitNotes.html(productFitNotes);
      $productShopModelSize.html(productModelSize);
      $productDynamicFabric.html(productFabric);
      $productDynamicFabricDescription.html(productFabricDescription);
      $productDynamicFabricUrl.html(productFabricUrl);
      //$productDynamicFabricUrl.attr('href', productFabricUrl);
    
      $productCombDynamicFabric.text(productFabric).attr('href', productFabricUrl);
    
      $productShopFabricComp.html(productFabricComp);


    
      // update description
      //$productShopDescription.html(productDescription);
    
      // sale notice
      if (variantIsFinalSale){
        $('.card__inline-text').removeClass('display-none')
      } else {
        $('.card__inline-text').addClass('display-none')
      }

      //update sku

      $productShopSku.text(variantSku);


      // update price
      $productShopPrice.html(variantPrice);


      // update url
      window.history.replaceState({}, document.title, productUrl + "?variant=" + variantID);


      // update add to cart variant id

      $addToCartBtn.attr('data-product-id', productID);
      $addToCartBtn.attr('data-variant-id', variantID);



      // update add to cart button text, class

      removeClassWithPrefix($addToCartBtn, 'js-');

      $addToCartBtn.addClass(productBtnJSClass).text(productBtnText);


      // update inventory

      $inventoryNotice.find('span').text(variantInventoryQTY);

      if(variantIsLowInStock){
          $inventoryNotice.addClass('active');
      }
      else{
          $inventoryNotice.removeClass('active');
      }

      $incomingNotice.find('span').text(variantIncomingDate);

      if (variantIsBackOrder) {
          $incomingNotice.addClass('active');
      }
      else{
          $incomingNotice.removeClass('active');
      }


      // //Update related
      // $('.ymal-loop').removeClass('active')
      // $('.ymal-container').find("[data-product-handle='" + productHandle + "']").addClass('active');


      // if( !$('.ymal-loop.active').children().length ){
      //   $('.section-title').text('')
      // } else {
      //   $('.section-title').text('You May Also Like')
      // }

      //Update breadcrumb
      var pretty = prettify(productHandle)
      $('.page-title').text(pretty)

      //update description

      // if (productDescription.includes('<!--split-->')){
      //   console.log("yes it does");
      // var descriptions =  productDescription.split('<!--split-->')
      // }
      //
      // console.log(split);
      $('.product-selector.product-shop-selector.active').find('.forSelectClick').eq(0).click();
  });



  /* =========================================================================
      Product Shop Variant
  ========================================================================= */



  $(document).on('sync click', '.js-product-shop-variant', function(){

      var $this = $(this);

      $this.addClass('selected').siblings().removeClass('selected');

      // data

      var productID = $this.data('product-id');

      var productBtnText = $this.data('product-btn-text');

      var productBtnJSClass = $this.data('product-btn-js-class');


      var variantID = $this.data('variant-id');

      var variantPrice = $this.data('variant-price-html');

      var variantInventoryQTY = $this.data('variant-inventory-quantity');

      var variantIncomingDate = $this.data('variant-incoming-date');

      var variantIsLowInStock = $this.data('variant-is-low-in-stock');

      var variantIsBackOrder = $this.data('variant-is-back-order');

      var variantIsSoldOut = $this.data('variant-is-sold-out');


      // end of data


      // element

      var $productShop = $this.parents('.product-shop');

      var $productShopPrice = $productShop.find('.product-shop-price');

      var $inventoryNotice = $productShop.find('.product-shop-inventory-notice');

      var $incomingNotice = $productShop.find('.product-shop-incoming-notice');

      var $backInStock = $productShop.find('.product-back-in-stock');

      var $addToCartBtn = $productShop.find('.product-add-to-cart');


      // end of element

    setTimeout(function(){ 
       if ($(".product-shop-add-to-cart").hasClass("js-product-add-to-cart")) {
//           console.log("has class asad")
          $(".product-shop-back-in-stock").hide();
         $('.js-product-add-to-cart').show();
        }
        else{
//           console.log("has no asad")
         $(".product-shop-back-in-stock").show();
          $('.js-product-back-in-stock-submit').hide();
        }
      }, 500);

      // update price
      $productShopPrice.html(variantPrice);

      // update url
      window.history.replaceState({}, document.title, "?variant=" + variantID);


      // update add to cart variant id

      $addToCartBtn.attr('data-product-id', productID);
      $addToCartBtn.attr('data-variant-id', variantID);


      // update add to cart button text, class

      removeClassWithPrefix($addToCartBtn, 'js-');

      $addToCartBtn.addClass(productBtnJSClass).text(productBtnText);

      // update inventory

      $inventoryNotice.find('span').text(variantInventoryQTY);

      if(variantIsLowInStock){
          $inventoryNotice.addClass('active');
      }
      else{
          $inventoryNotice.removeClass('active');
      }

      $incomingNotice.find('span').text(variantIncomingDate);

      if (variantIsBackOrder) {
          $incomingNotice.addClass('active');
      }
      else{
          $incomingNotice.removeClass('active');
      }





  });


  
  /* =========================================================================
      Back in stock
  ========================================================================= */

  
  
  
  $(document).on('click', '.product-shop-back-in-stock-submit',function(event) {

    var $this = $(this);
//     console.log($this.text());
  if($this.text() == 'Thank you!'){
   event.preventDefault();
//     console.log('asad button text',$this.text());
  }else{
   
    if($this.parents('.product-shop-function-bar_hidebyiftikhar').hasClass('is_stuck')){
        
        $("html, body").animate({
            scrollBottom: 0
        }, 600, 'easeOutExpo');        

    }

    else{

        var $emailInput = $('.product-shop-back-in-stock-email');

        var email = $emailInput.val();

        var productID = $('.product-shop-add-to-cart').attr('data-product-id');

        var variantID = $('.product-shop-add-to-cart').attr('data-variant-id');
     
      	var title = $('.product-shop-selector.active').attr('data-product-handle');
  
    	var size = $('.js-dropdown-toggle-update.selected').find('span').html(); 
       
      var settings = {
  "async": true,
  "crossDomain": true,
  "url": "https://bisdl1961.herokuapp.com/bis",
  "method": "POST",
  
  "headers": {
    "Content-Type": "application/json",
  },
  "processData": false,
  //"data": "{\"txt\": \"147932\"}"
        "data": JSON.stringify({ email:email, pid:productID, vid:variantID, title:title, size:size })
}
      if(email){
$.ajax(settings).done(function (data) {
//         console.log("dataasad", JSON.stringify(data));
  var data = JSON.parse(data);
           var msg = '';

            if (data.message == 'Subscriber Added') {

              msg = 'Thank you';
            }

            else {

              if (data.error == 'Validation error') {

              msg = 'invalid email';
            }
               

            }

            $this.text(msg);
  
}).fail(function (data) {
      
          var msg = 'invalid email';

            $this.text(msg);
  
});
      }


    }
  }
});
  
  
  
  /* =========================================================================
      Product Shop Option Value
  ========================================================================= */


  $(document).on('click', '.js-product-shop-option-value', function(){


      var $this = $(this);

      $this.addClass('selected').siblings().removeClass('selected');


      // data

      var optionPosition = $this.data('option-position');

      var optionValue = $this.data('option-value');


      // element

      var $productShopSelector = $this.parents('.product-shop-selector');

      var $productShopVariants = $productShopSelector.find('.product-shop-variants');

      var $productShopVariant = $productShopVariants.find('.product-shop-variant');

      var $productShopOptions = $productShopSelector.find('.product-shop-options');

      var $productShopOptionValue = $productShopOptions.find('.product-shop-option-value');

      var productShopSelectedOption1 = $productShopOptionValue.filter('.selected[data-option-position="1"]').data('option-value') || '';

      var productShopSelectedOption2 = $productShopOptionValue.filter('.selected[data-option-position="2"]').data('option-value') || '';

      var productShopSelectedOption3 = $productShopOptionValue.filter('.selected[data-option-position="3"]').data('option-value') || '';

      var $productShopSelectedVariant = $productShopVariant.filter(function(index) {

          var option1 = $(this).data('variant-option1');

          var option2 = $(this).data('variant-option2');

          var option3 = $(this).data('variant-option3');

          return option1 == productShopSelectedOption1 && option2 == productShopSelectedOption2 && option3 == productShopSelectedOption3
      });



      $productShopSelectedVariant.trigger('sync');
      // sync variant selector with option selector

  });







  /* =========================================================================
      Product Add to Cart
  ========================================================================= */

function addcart() {
    //alert("test");
     var variantID = $('.js-product-add-to-cart').attr('data-variant-id');
      CartJS.addItem(variantID, 1, {}, {
      "success": function(data, textStatus, jqXHR) {
        //Open Mini Cart
        setTimeout(function(){
            $('body').addClass('mini-cart-open');
        }, 500);

      },
      "error": function(jqXHR, textStatus, errorThrown) {
      }
      });
  
}

  

   $(document).on('click', '.js-product-add-to-cart', function(){
//     $('.product-shop-selector.active').find('.product-shop-size-option-dropdown-toggle.dropdown-toggle.product-shop-option-name.js-dropdown-toggle span').length
// if($('.product-shop-size-option-dropdown-toggle.dropdown-toggle.product-shop-option-name.js-dropdown-toggle').find('span').length == 0) {
     if($('.product-shop-selector.active').find('.product-shop-size-option-dropdown-toggle.dropdown-toggle.product-shop-option-name.js-dropdown-toggle').length == 0){
     
        //call Add to cart Function
       addcart();
     }
     else {
    if($('.product-shop-selector.active').find('.product-shop-size-option-dropdown-toggle.dropdown-toggle.product-shop-option-name.js-dropdown-toggle').length == 2){
  if($('.product-shop-selector.active').find('.product-shop-size-option-dropdown-toggle.dropdown-toggle.product-shop-option-name.js-dropdown-toggle span').length <= 1) {
    alert('Please select size/inseam to proceed.');
   
} else{
        //call Add to cart Function
  addcart();

  }
    }else{
      
      if($('.product-shop-selector.active').find('.product-shop-size-option-dropdown-toggle.dropdown-toggle.product-shop-option-name.js-dropdown-toggle span').length == 0) {
    alert('Please select size to proceed.');
   
} else{
        //call Add to cart Function
    addcart();
        
  }
    
    }}
  });

  


  /* =========================================================================
      Cart Quantity Input
  ========================================================================= */
$(document).on("click", ".quantity-up", function(e){

        $quantity = $(this).parents('.quantity');
        $input = $quantity.find('input');
        min = $input.attr('min'),
        max = $input.attr('max');
        currentValue = parseFloat($input.val());

        if (currentValue >= max) {
          var newVal = currentValue;
        } else {
          var newVal = currentValue + 1;
        }
        $input.val(newVal);
        $input.trigger("change");

    });

    $(document).on("click", ".quantity-down", function(e){

        $quantity = $(this).parents('.quantity');
        $input = $quantity.find('input');
        min = $input.attr('min'),
        max = $input.attr('max');
        currentValue = parseFloat($input.val());

        if (currentValue <= min) {
            var newVal = currentValue;
        } else {
            var newVal = currentValue - 1;
        }
        $input.val(newVal);
        $input.trigger("change");

    });


  // $(document).on('keyup', '.js-line-item-quantity-input', _.debounce(function() {
  //
  //     var lineQuantity = parseInt($(this).val());
  //     var lineNumber= parseInt($(this).data('line-number'));
  //
  //     CartJS.updateItem(lineNumber, lineQuantity);
  //
  // }, 300));
  //
  //


/* =========================================================================
    Dropdown
========================================================================= */

 // if ($('html.no-touch').length) {
 //
 //    $('.js-dropdown-hover').hover(
 //        function() {
 //            $(this).addClass('open');
 //        },
 //         function() {
 //            $(this).removeClass('open');
 //        });
 //
 // }



    $(document).on('click', '.js-dropdown-toggle', function() {

        var $dropdown = $(this).parent();

        $dropdown.toggleClass('open')
                .siblings().removeClass('open');

    });


 $(document).on('click', '.js-dropdown-toggle-update', function() {

    var $this = $(this);

 
     if($this.hasClass( "unavailable" )){
//      console.log('has class');
       $(".product-shop-back-in-stock").addClass( "active" );
       $('.js-product-back-in-stock-submit').hide();
     }else{
//      console.log('has no class');
       $(".product-shop-back-in-stock").removeClass( "active" );
       $('.js-product-add-to-cart').show();
     }


    $this.parents('.dropdown').find('.dropdown-toggle').html($this.html());
     $this.parents('.dropdown').removeClass('open');

});




  /* =========================================================================
      Remove Delimeter in SearchResults
  ========================================================================= */


var changeResult = setInterval( function(){
                    if ( $('.os-name').length ){
                      var $names = $('.os-name')
                      $names.each(function(i){
                        $($names[i]).text($($names[i]).text().replace(/\|/g, ''))
                      })
                      clearInterval(changeResult)
                    }
                  }, 100)



function prettify(str) {
    return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) {
        return (prep && ' ') + letter.toUpperCase();
    });
}


/* =========================================================================
    Body Class
========================================================================= */


$(document).on('click', '.js-body-add-class', function() {
    $('body').addClass($(this).data('body-class'));
});

$(document).on('click', '.js-body-remove-class', function() {
    $('body').removeClass($(this).data('body-class'));
});

$(document).on('click', '.js-body-toggle-class', function() {
    $('body').toggleClass($(this).data('body-class'));
});


})  // <== bottom of wrapper
